export const OFFICE_COORDS = { lat: 12.866391, lng: 77.535354 };

export const MAP_EMBED_URL = `https://www.google.com/maps?q=${OFFICE_COORDS.lat},${OFFICE_COORDS.lng}&z=16&output=embed`;
